import { useShareLink } from "@/hooks/useShareLink/useShareLink";
import { ShareFilled } from "@aircall/icons";
import { Button, Tooltip } from "@aircall/tractor";
import { useTranslation } from "react-i18next";

const DELAY = 200;

export function ShareLink() {
  const { t } = useTranslation();
  const handleOnClick = useShareLink();

  return (
    <Tooltip mouseEnterDelay={DELAY} title={t("copy_link")}>
      <Button
        data-test="player-share-link"
        onClick={handleOnClick}
        variant="secondary"
        mode="ghost"
        size="small"
      >
        <ShareFilled />
      </Button>
    </Tooltip>
  );
}
